import React from 'react';
import { useEffect, useState } from 'react';
import SwiperCore, {
  FreeMode, Navigation
} from 'swiper';
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Swiper, SwiperSlide } from 'swiper/react';
import useWindowResize from '../../hooks/useWindowResize';
import styles from './HeadCarousel.module.scss';

SwiperCore.use([FreeMode, Navigation]);

const HeadCarousel = ({ listOfPictures }) => {
  const isBelowMedium = useWindowResize(768)
  const [images, setImages] = useState([])

  useEffect(() => {
    setImages(isBelowMedium ? listOfPictures.map(d => ({ src: d.image_mobile.src, alt: d.image_mobile.alt })) : listOfPictures.map(d => ({ src: d.image.src, alt: d.image.alt })))
  }, [isBelowMedium])

  return (
    <div className={`${styles.HeadCarousel} headCarousel`}>
      <Swiper
        slidesPerView={3}
        loop
        centeredSlides
        centeredSlidesBounds
        centerInsufficientSlides
        navigation
      >
        {images && images.length > 0 && images.map((d, i) => (
          <SwiperSlide key={'swiper-slide-head-' + i}>
            <div key={'carouselpic' + i} className="carouselPic">
              <div className={styles.carouselSlideContent}>
                <div className={styles.currentImageContainer}>
                  <img src={d.src} alt={d.alt} />
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default HeadCarousel;
